import "./SentryInstrumentation";
import * as React from "react";
import * as ReactDOM from "react-dom";
import App from "./App";
import "./index.css";
import "./services/log/logger";
import {deviceStateService} from "./services/device/device-state-service";
// Boot the lessonService singleton at startup so its route/native-app/scorer/midi listeners
// are wired before any route mounts (previously triggered transitively by lessonActions).
import "./services/lesson/lessonService";
import {pageViewTracking} from "./services/analytics/pageViewTracking";

deviceStateService.init();
// Wire the GA4 in_app_page_view tracker to the route-changed event bus.
pageViewTracking.init();

ReactDOM.render(<App />, document.getElementById("root") as HTMLElement);

/**
 * The app initially was deployed with a service worker, which will keep running and caching until you unregister it.
 */
async function unregisterServiceWorker(){
  if(!navigator || !navigator.serviceWorker){ return; } //native app issue
  const registrations = await navigator.serviceWorker.getRegistrations();
  for(const registration of registrations) {
    void registration.unregister();
  }
}

void unregisterServiceWorker();
